import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const FilterIcon = props => {
  return (
    <SvgIcon {...props} width="23.5" height="24.5" viewBox="0 0 23.5 24.5">
      <path
        fill="#231f20"
        d="M14.578,32.5a.78.78,0,0,1-.379-.1.974.974,0,0,1-.492-.865V22.3l-8.069-9.8a2.913,2.913,0,0,1-.425-2.9A2.445,2.445,0,0,1,7.444,8h18.62A2.445,2.445,0,0,1,28.3,9.6a2.913,2.913,0,0,1-.425,2.9L19.8,22.3V27.7a1,1,0,0,1-.326.749l-4.352,3.843A.821.821,0,0,1,14.578,32.5ZM7.444,9.922a.7.7,0,0,0-.639.461.836.836,0,0,0,.121.832l8.3,10.088a1.017,1.017,0,0,1,.226.629v7.609l2.611-2.325V21.931a1.019,1.019,0,0,1,.226-.649l8.3-10.088a.838.838,0,0,0,.1-.817.7.7,0,0,0-.622-.456ZM18.93,27.7Z"
        transform="translate(-5.004 -8)"
      />
    </SvgIcon>
  );
};

export default FilterIcon;
